import React, { useEffect, useState, useRef, useMemo } from 'react';
//Dynamically load components on request for faster page rendering
import loadable from '@loadable/component';
import { useUserState } from '../../../hook/customerHook';
import { useHistory } from 'react-router-dom';
import makeStyles from '@mui/styles/makeStyles';
import Grid from '@mui/material/Grid';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Badge from '@mui/material/Badge';
import AssignTasks from '../../comps/DetailsPageTabs/CustomTab/EditPopUp/FormFields/AssignTasks';
import Alert from '@mui/material/Alert';
import { getCommentsAndTags, getUserTaskBoard } from '../../../api/serverRequests';
import {
	saveSelection,
	deleteFromCollection,
	searchMyCollection,
	searchListing,
	getRoutesForSelection,
	getActiveAgents,
	submitPropertyCustomData,
	getPdfOfCustomMultipleListing,
	sendToFollowUpBoss
} from '../../../api/serverRequests';

import { imageResolver } from '../../../helper/image-resolver';
import CusPaginationActions from './CusPaginationActions';
import { cusTheme } from './cusTheme';
import {
	currencyParser,
	correctKnockabilityValue,
	displayHumanReadableDate
} from '../../../helper/parser';
import ReactToPrint from 'react-to-print';
import {
	Box,
	IconButton,
	Button,
	Tooltip,
	CircularProgress,
	Snackbar,
	FormControlLabel,
	Accordion,
	AccordionDetails,
	AccordionSummary,
	useMediaQuery,
	FormControl,
	InputLabel,
	Select,
	MenuItem
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import InfoIcon from '@mui/icons-material/Info';

import { Print } from '@mui/icons-material';

import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogContent';
import MuiDialogTitle from '@mui/material/DialogTitle';

import HotelIcon from '@mui/icons-material/Hotel';
import BathtubIcon from '@mui/icons-material/Bathtub';
import KitchenIcon from '@mui/icons-material/Kitchen';
import SquareFootIcon from '@mui/icons-material/SquareFoot';

import MapResults from '../MapResults';
import withStyles from '@mui/styles/withStyles';
import {
	getHomeCommentsByOrganization,
	getHomeTagsByOrganization
} from '../../../api/serverRequests';
import RenderTags from '../DetailsPageTabs/CustomTab/RenderTags';
import RenderComments from '../DetailsPageTabs/CustomTab/RenderComments';
import Favorite from '@mui/icons-material/Favorite';

import FavoriteBorder from '@mui/icons-material/FavoriteBorder';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import CustomOwnerLetterDialog from '../Dialogs/CustomOwnerLetterDialog';

import { blue } from '@mui/material/colors';

const Avatar = loadable(() => import('@mui/material/Avatar'));
const Checkbox = loadable(() => import('@mui/material/Checkbox'));
const Table = loadable(() => import('@mui/material/Table'));
const TableBody = loadable(() => import('@mui/material/TableBody'));
const TableCell = loadable(() => import('@mui/material/TableCell'));
const TableContainer = loadable(() => import('@mui/material/TableContainer'));
const TablePagination = loadable(() => import('@mui/material/TablePagination'));
const TableRow = loadable(() => import('@mui/material/TableRow'));
const Paper = loadable(() => import('@mui/material/Paper'));
const CusTableHead = loadable(() => import('./CusTableHead'));
const CusTableToolbarOffMarket = loadable(() => import('./CusTableToolbarOffMarket'));
const VisibilityIcon = loadable(() => import('@mui/icons-material/Visibility'));

const styles = (theme) => ({
	root: {
		backgroundColor: theme.palette.background.paper,
		height: '100%',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center'
	},
	button: {
		flex: 1,
		color: blue[900],
		margin: 10,
		justifyContent: 'center',
		alignSelf: 'center',

		'&.MuiButton-root.active': {
			color: '#FF0000',
			borderColor: '#FF0000'
		}
	},
	backdrop: {
		zIndex: theme.zIndex.drawer + 1,
		color: '#fff'
	},
	closeButton: {
		position: 'absolute',
		right: theme.spacing(1),
		top: theme.spacing(1),
		color: theme.palette.grey[500]
	},
	dialogContent: {
		width: '500px',
		height: '155px',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'flex-end',
		marginBottom: '14px',
		justifyContent: 'center',
		alignItems: 'center'
	},
	dialogTitle: {
		backgroundColor: theme.palette.background.paper,
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		textAlign: 'center'
	}
});
const delay = (ms) => new Promise((res) => setTimeout(res, ms));
const useStyles = (props) =>
	makeStyles((theme) => ({
		collectionInUser: {
			backgroundColor: cusTheme.palette.primary.light
		},
		collectionInOrganization: {
			backgroundColor: cusTheme.palette.secondary.light
		},
		pic: {
			backgroundColor: theme.palette.text.secondary,
			borderRadius: '8px',
			[theme.breakpoints.down('sm')]: {
				width: '75px',
				height: '75px'
			},
			[theme.breakpoints.up('sm')]: {
				width: '100px',
				height: '75px'
			}
		},
		imageContainer: {
			position: 'relative',
			flexShrink: 0
		},
		statusTagLine: {
			display: 'inline-block',
			marginTop: theme.spacing(0.25),
			backgroundColor: 'rgba(0, 0, 0, 0.6)',
			color: 'white',
			padding: theme.spacing(0.5, 1),
			borderRadius: '4px',
			fontSize: '0.75rem',
			fontWeight: 'bold'
		},
		assignedText: {
			fontSize: '0.9rem',
			color: theme.palette.text.secondary,
			margin: `${theme.spacing(0.5)}px 0`
		},
		tableContainer: {
			height: '80vh',
			overflowY: 'auto'
		},
		printIcon: {
			'&:hover, &.Mui-focusVisible': { backgroundColor: 'white' }
		},
		printIconContainer: {
			display: 'flex',
			width: '100%',
			justifyContent: 'flex-end'
		},
		mapButton: {
			margin: theme.spacing(1)
		},
		pagination: {
			'&.MuiTableCell-root': {
				paddingTop: theme.spacing(2),
				border: 'none'
			},
			'& .MuiToolbar-root': {
				flexWrap: 'wrap',
				justifyContent: 'flex-end'
			},
			'& .MuiTablePagination-selectRoot': {
				marginRight: 0
			},
			'& .MuiTablePagination-caption': {
				marginLeft: theme.spacing(1),
				[theme.breakpoints.up('sm')]: {
					marginLeft: theme.spacing(4)
				}
			}
		},
		closeButton: {
			position: 'absolute',
			right: theme.spacing(1),
			top: theme.spacing(1),
			color: theme.palette.grey[500]
		},
		summaryButton: {
			height: '10px',
			width: '10px',
			fontSize: '10px',
			color: '#004F2B'
		},
		printButtons: {
			marginTop: '30px',
			marginLeft: '98px',
			display: 'flex',
			alignItems: 'space-between'
		},
		dialogContent: {
			width: '250px',
			height: '130px',
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'flex-end',
			marginBottom: '14px',
			flexDirection: 'column'
		},
		dialogPrintContent: {
			width: '250px',
			height: '130px',
			display: 'flex',
			flexDirection: 'column'
		},
		popupLabel: {
			marginTop: '20px'
		},
		checkBox: {
			backgroundColor: 'blue',
			cursor: 'pointer',
			accentColor: '#004F2B'
		},
		printListings: {
			fontSize: '15px',
			marginLeft: '25px',
			fontWeight: 'bold'
		},
		printScaleText: {
			fontSize: '10px',
			marginLeft: '25px',
			marginTop: '-14px',
			color: 'grey'
		},
		comingSoon: {
			fontSize: '10px',
			fontStyle: 'italic',
			color: 'grey'
		},
		backdrop: {
			zIndex: theme.zIndex.drawer + 1,
			color: '#fff'
		},
		hoverElement: {
			position: 'relative',
			'&:hover': {
				'& $hoverBox': {
					display: 'block'
				}
			}
		},
		hoverBox: {
			zIndex: 100,
			display: 'none',
			background: 'white',
			border: '1px solid gray',
			position: 'absolute',
			padding: '0 1rem',
			whiteSpace: 'nowrap'
		},
		hoverBox_tags: {
			color: '#3f51b5'
		},
		commentBox: {
			margin: '10px',
			'& h6': {
				whiteSpace: 'nowrap'
			},
			'& span': {
				fontSize: '1rem'
			}
		},
		spinner: {
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',
			height: '100%',
			margin: '2rem'
		},
		resultsContainer: {
			display: 'grid',
			gap: theme.spacing(2),

			[theme.breakpoints.up(1100)]: {
				gap: theme.spacing(1)
			}
		},
		listingCard: {
			margin: theme.spacing(1, 0),
			borderRadius: '8px',
			boxShadow: '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)',
			transition: 'all 0.3s cubic-bezier(.25,.8,.25,1)',
			'&:hover': {
				boxShadow: '0 7px 14px rgba(0,0,0,0.25), 0 5px 5px rgba(0,0,0,0.22)'
			}
		},
		priceLine: {
			borderBottom: '1px solid lightgray',
			padding: theme.spacing(1, 0),
			marginBottom: theme.spacing(1),
			gap: theme.spacing(1),
			fontWeight: 'bold',

			[theme.breakpoints.up(1100)]: {
				display: 'inline-flex',
				flexFlow: 'column nowrap',
				width: 'unset !important',
				borderBottom: 'none',
				padding: '0',
				marginBottom: '0',
				gap: '0',
				justifyContent: 'center',
				textAlign: 'center'
			}
		},
		listingAddress: {
			fontWeight: 'bold',

			'& a': {
				color: 'black',
				textDecoration: 'none'
			}
		},
		iconLine: {
			display: 'flex',
			flexWrap: 'wrap',
			alignItems: 'center',
			color: theme.palette.text.secondary,
			[theme.breakpoints.down('md')]: {
				gap: theme.spacing(1),
				marginTop: theme.spacing(0.5)
			},
			[theme.breakpoints.up('md')]: {
				gap: theme.spacing(2),
				marginTop: theme.spacing(1)
			}
		},
		iconItem: {
			display: 'inline-flex',
			alignItems: 'center',
			gap: theme.spacing(0.5)
		},
		mlsLine: {
			color: theme.palette.text.secondary,
			[theme.breakpoints.up('md')]: {
				fontSize: '0.9rem'
			},
			[theme.breakpoints.down('md')]: {
				fontSize: '0.8rem',
				marginTop: theme.spacing(0.5)
			}
		},
		topRow: {
			alignItems: 'center',
			justifyContent: 'space-between',
			flexFlow: 'row nowrap',
			width: '100%',

			[theme.breakpoints.up(1100)]: {
				justifyContent: '',
				display: 'inline-flex',
				width: 'unset !important'
			}
		},
		smallFavorite: {
			[theme.breakpoints.up(1100)]: {
				display: 'none'
			}
		},
		bigFavorite: {
			[theme.breakpoints.down(1100)]: {
				display: 'none'
			}
		},
		additionalInfo: {
			position: 'relative',
			top: '-4px',
			[theme.breakpoints.up(1100)]: {
				display: 'inline-flex',
				flexFlow: 'column nowrap'
			}
		},
		secondaryTextLine: {
			fontSize: '0.9rem',
			[theme.breakpoints.down('md')]: {
				fontSize: '0.875rem'
			},
			[theme.breakpoints.up(1100)]: {
				color: theme.palette.text
			}
		},
		insideAccordion: {
			display: 'block'
		},
		accordian: {
			borderRadius: '8px !important',
			'&:before': {
				display: 'none'
			},
			'&:hover': {
				backgroundColor: 'rgba(0, 79, 43, 0.04)' // Lighter green on hover
			}
		},
		contentContainer: {
			width: '100%',
			padding: '8px 16px',
			paddingBottom: '8px !important'
		},
		priceInfo: {
			[theme.breakpoints.up('md')]: {
				textAlign: 'center'
			}
		},
		avatarAddress: {
			display: 'flex',
			alignItems: 'center',
			gap: theme.spacing(1.5)
		},
		customDialog: {
			maxWidth: '400px',
			width: '100%'
		},
		dialogContentAgents: {
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'center',
			alignItems: 'center',
			padding: '16px 24px'
		}
	}));

const DialogTitle = withStyles(styles)(({ children, classes, onClose, ...other }) => {
	return (
		<MuiDialogTitle disableTypography className={classes.dialogTitle} {...other}>
			<Typography variant="h6">{children}</Typography>
			{onClose ? (
				<IconButton
					aria-label="close"
					className={classes.closeButton}
					onClick={onClose}
					size="large"
				>
					<CloseIcon />
				</IconButton>
			) : null}
		</MuiDialogTitle>
	);
});

const StyledBadge = withStyles((theme) => ({
	badge: {
		backgroundColor: 'var(--badge-color)',
		boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
		'&::after': {
			position: 'absolute',
			top: 0,
			left: 0,
			width: '100%',
			height: '100%',
			borderRadius: '50%',
			border: '1px solid currentColor',
			content: ''
		}
	}
}))(Badge);

function getKnockabilityColor(knockability) {
	if (knockability >= 80) {
		return '#57A75B';
	} else if (knockability >= 50) {
		return '#FFCE22';
	} else {
		return '#FF0000';
	}
}
function getPropertyStatus(status) {
	switch (status) {
		case 'A':
		case 'AU':
			return { text: 'Active', color: '#57A75B' };
		case 'S':
		case 'P':
		case 'F':
			return { text: 'Sold', color: '#D32F2F' };
		case 'T':
			return { text: 'Terminated', color: '#757575' };
		case 'C':
			return { text: 'Cancelled', color: '#757575' };
		case 'X':
			return { text: 'Expired', color: '#757575' };
		default:
			return null;
	}
}

function ListingCard({
	mlNum,
	status,
	homeId,
	address,
	price,
	assessment,
	beds,
	bathrooms,
	expiryDate,
	kitchens,
	totalArea,
	selected,
	favSelected,
	setFavSelected,
	knockability,
	pic,
	row,
	depth,
	frontage,
	propertyArea,
	onCheckClick,
	getAddress,
	selectedRoute,
	planRoutes,
	openInNewTab,
	AssignedAt,
	isTaskBoard,
	isSearchActivePage,
	...other
}) {
	const areaRounded = Math.round(parseFloat(totalArea));
	const linkToDetailsPage = mlNum ? mlNum : homeId;
	const formatLotSize = () => {
		const cleanValue = (value) => {
			if (value && value.length > 1 && value.includes('(')) {
				return parseInt(value.split('(')[0].trim());
			}
			return parseInt(value);
		};
		if (depth && frontage && totalArea !== null) {
			const depthFixed = cleanValue(depth) || '-';
			const frontageFixed = cleanValue(frontage) || '-';
			const areaRounded1 = areaRounded || '-';

			// Build the string with the desired format
			return `${frontageFixed}\u00D7${depthFixed} (${areaRounded1})`;
		}
		return false;
	};

	const propertyStatus = getPropertyStatus(status);
	const classes = useStyles({ isSearchActivePage })();
	const [checked, setChecked] = useState(favSelected);
	const [expand, setExpand] = useState(false);
	const [loading, setLoading] = useState(false);
	const [comments, setComments] = useState([]);
	const [tags, setTags] = useState([]);
	const [secondaryInfo, setSecondaryInfo] = useState({});
	const [userState, dispatchUser] = useUserState();

	// Calculate property status information only once
	const propertyStatusInfo = useMemo(() => {
		const status = row['Status'];
		if (!isTaskBoard) return null;
		if (status === 'A' || status === 'AU') {
			return {
				show: true,
				message: 'Property is active',
				color: '#FF9900'
			};
		} else if ((status === 'S' || status === 'P' || status === 'F') && row['SoldDate']) {
			// Check if sold within the past year
			const soldDate = new Date(row['SoldDate']);
			const currentDate = new Date();
			const diffTime = Math.abs(currentDate - soldDate);
			const diffMonths = Math.ceil(diffTime / (1000 * 60 * 60 * 24 * 30));

			if (diffMonths <= 12) {
				return {
					show: true,
					message: `Property sold date is ${row['SoldDate']}`,
					color: '#004F2B'
				};
			}
		}

		return null;
	}, [row['Status'], row['SoldDate'], isTaskBoard]);

	useEffect(() => {
		if (expand && loading == true) {
			const fetchData = async () => {
				getCommentsAndTags(homeId)
					.then((res) => {
						if (res.status === 200) {
							setSecondaryInfo(res.data.secondaryInfo);
							const { Tags = [], Comments = [] } = res.data.secondaryInfo || {};
							setComments(Comments);
							setTags(Tags);
							setLoading(false);
						}
					})
					.catch((err) => {
						console.error(err.message);
						setLoading(false);
					});
			};
			fetchData();
		}
	}, [homeId, expand, loading]);

	const navigation = useHistory();
	const theme = useTheme();
	const renderAssessmentSearchActive = () => {
		if (!isSearchActivePage) return;
		if (row['DealType'] === 'price_dropped') {
			return (
				<Typography className={classes.secondaryTextLine} variant="body1">
					{row['PrevPrice'] > 0
						? 'Prev ' +
						  parseInt(row['PrevPrice']).toLocaleString('en-US', {
								style: 'currency',
								currency: 'USD',
								minimumFractionDigits: 0,
								maximumFractionDigits: 0
						  })
						: 'No previous price yet.'}{' '}
					({row['Percent']}%)
				</Typography>
			);
		} else if (row['DealType'] === 'active') {
			return (
				<Typography className={classes.secondaryTextLine} variant="body1">
					{row['LastSoldPrice'] > 0
						? 'Last sold for ' + currencyParser(row['LastSoldPrice'])
						: 'No last sold price found.'}{' '}
					({row['Percent']}%)
				</Typography>
			);
		} else if (row['DealType'] === 'below_estimate') {
			return (
				<Typography className={classes.secondaryTextLine} variant="body1">
					{row['EstimateMid'] > 0
						? 'Below estimation of ' + currencyParser(row['EstimateMid'])
						: 'No estimation found.'}{' '}
					({row['Percent']}%)
				</Typography>
			);
		} else {
			return (
				<Typography className={classes.secondaryTextLine} variant="body1">
					{row['Assessment'] > 0
						? 'Assessed for ' + currencyParser(row['Assessment'])
						: 'No assessment yet.'}{' '}
					{!isNaN(row['Percent']) ? `(${row['Percent']}%)` : ''}
				</Typography>
			);
		}
	};

	return (
		<>
			<Card
				className={classes.listingCard}
				style={{
					border: selectedRoute ? `1px solid ${theme.palette.primary.main}` : 'none',
					backgroundColor: selectedRoute && 'rgba(72, 193, 198, 0.1)'
				}}
			>
				<Accordion className={classes.accordian} elevation={0}>
					<AccordionSummary
						expandIcon={<ExpandMoreIcon />}
						onClick={() => {
							setExpand(!expand);
							setLoading(!loading);
						}}
					>
						<CardContent
							className={classes.contentContainer}
							style={{ flexGrow: 1, paddingRight: '0px' }}
						>
							<Grid container alignItems="center" spacing={2}>
								{/* Col 1: Checkbox, Image, Address */}
								<Grid
									item
									xs={12}
									md={4}
									style={{
										marginLeft: '-20px',
										display: 'flex',
										alignItems: 'center'
									}}
								>
									{!planRoutes && (
										<Checkbox
											inputProps={{
												'aria-labelledby': mlNum + '__' + homeId
											}}
											id="selectedListing"
											checked={selected}
											onClick={(event) => {
												onCheckClick(
													event,
													row['MLNum'] + '__' + row['HomeId'],
													address
												);
												getAddress(event, address);
											}}
										/>
									)}
									<div
										className={classes.avatarAddress}
										style={{ flexGrow: 1, marginLeft: '8px' }}
									>
										<div className={classes.imageContainer}>
											{knockability !== 0 ? (
												<StyledBadge
													className={classes.knockabilityBadge}
													overlap="rectangular"
													anchorOrigin={{
														vertical: 'bottom',
														horizontal: 'right'
													}}
													variant="dot"
													style={{
														'--badge-color': getKnockabilityColor(
															correctKnockabilityValue(knockability)
														)
													}}
												>
													<Avatar
														className={classes.pic}
														variant="rounded"
														alt=""
														src={imageResolver(pic)}
													/>
												</StyledBadge>
											) : (
												<Avatar
													className={classes.pic}
													variant="rounded"
													alt=""
													src={imageResolver(pic)}
												/>
											)}
										</div>
										<div>
											<Typography className={classes.listingAddress}>
												<a
													href={`/user/listing/${linkToDetailsPage}`}
													rel="noopener noreferrer"
													onClick={(event) => {
														event.preventDefault();
														if (openInNewTab)
															window.open(
																`/user/listing/${linkToDetailsPage}`
															);
														else
															navigation.push(
																`/user/listing/${linkToDetailsPage}`
															);
													}}
												>
													{isSearchActivePage
														? `${address}, ${row['Area']}`
														: address}
												</a>
											</Typography>
											{isTaskBoard && (
												<Typography className={classes.assignedText}>
													Assigned {displayHumanReadableDate(AssignedAt)}
												</Typography>
											)}
											{status && propertyStatus && (
												<div
													className={classes.statusTagLine}
													style={{
														backgroundColor: propertyStatus.color
													}}
												>
													{propertyStatus.text}
												</div>
											)}
											{renderAssessmentSearchActive()}
										</div>
									</div>
								</Grid>

								{/* Col 2: Price & Assessed */}
								<Grid item xs={12} md={3} className={classes.priceInfo}>
									<Box
										sx={{
											display: 'flex',
											width: '100%',
											flexDirection: { xs: 'row', md: 'column' },
											justifyContent: {
												xs: 'flex-start',
												md: 'center'
											},
											alignItems: { xs: 'baseline', md: 'center' },
											gap: { xs: 1, md: 0 },
											pl: { md: 2 }
										}}
									>
										<Typography
											variant="h6"
											component="p"
											sx={{ fontSize: { xs: '1rem', md: '1.25rem' } }}
										>
											{price ? currencyParser(price) : ''}
										</Typography>
										<Typography
											className={classes.secondaryTextLine}
											variant="body2"
										>
											{assessment > 0
												? `Assessed for ${currencyParser(assessment)}`
												: ''}
										</Typography>
									</Box>
								</Grid>

								{/* Col 3: Details */}
								<Grid item xs={12} md={5}>
									<div className={classes.iconLine}>
										{beds > 0 && (
											<span className={classes.iconItem}>
												<HotelIcon fontSize="small" /> {beds} bd
											</span>
										)}
										{bathrooms > 0 && (
											<span className={classes.iconItem}>
												<BathtubIcon fontSize="small" /> {bathrooms} ba
											</span>
										)}
										{kitchens > 0 && (
											<span className={classes.iconItem}>
												<KitchenIcon fontSize="small" /> {kitchens} k
											</span>
										)}
										{propertyArea > 0 && (
											<span className={classes.iconItem}>
												<SquareFootIcon fontSize="small" /> {propertyArea}{' '}
												sf
											</span>
										)}
										{formatLotSize() && (
											<span className={classes.iconItem}>
												{formatLotSize()}
											</span>
										)}
									</div>
									{status === 'A' || status === 'AU' ? (
										<Typography className={classes.mlsLine}>
											MLS®# {mlNum} Listed on {row['ListDate']}
										</Typography>
									) : status === 'S' || status === 'P' || status === 'F' ? (
										<Typography className={classes.mlsLine}>
											MLS®# {mlNum} Closed on {row['SoldDate']}
										</Typography>
									) : status === 'T' || status === 'C' || status === 'X' ? (
										<Typography className={classes.mlsLine}>
											MLS®# {mlNum}{' '}
											{new Date(expiryDate) > new Date()
												? 'Expires on'
												: 'Expired on'}{' '}
											{expiryDate}
										</Typography>
									) : (
										''
									)}
								</Grid>
							</Grid>
						</CardContent>
						<Checkbox
							icon={<FavoriteBorder />}
							checkedIcon={<Favorite style={{ color: 'red' }} />}
							name="checkedH"
							checked={checked}
							onClick={(event) => {
								event.stopPropagation();
								const isChecked = event.target.checked;
								const listings = [mlNum + '__' + homeId];
								if (isChecked) {
									saveSelection({ listings });
									setFavSelected((prevSelected) => [...prevSelected, homeId]);
								} else {
									deleteFromCollection({ listings });
									setFavSelected((prevSelected) =>
										prevSelected.filter((id) => id !== homeId)
									);
								}
								setChecked(!checked);
							}}
						/>
					</AccordionSummary>

					<AccordionDetails>
						{loading ? (
							<div className={classes.spinner}>
								<CircularProgress />
							</div>
						) : comments.length > 0 || tags.length > 0 ? (
							<Table>
								{/* <div className={classes.insideAccordion}> */}
								<RenderTags homeId={homeId} tags={tags} setTags={setTags} />
								<br></br>
								<RenderComments comments={comments} setComments={setComments} />
								{/* </div> */}
							</Table>
						) : (
							<Typography variant="h6" component="h6">
								No comments or tags found
							</Typography>
						)}
					</AccordionDetails>
				</Accordion>
			</Card>
		</>
	);
}

export default function Lists({
	listings,
	setListings,
	title,
	listHeads,
	listCells,
	handleSelect,
	handleDelete,
	isSearch,
	initialOrderBy,
	initialSortOrder,
	isDetailsTable,
	isLoading,
	setIsLoading,
	filters,
	selectedRoute,
	destination,
	editAssignedTaskVisible,
	assignMyself,
	planRoutes,
	openInNewTab = false,
	isTaskBoard,
	isSearchActivePage = false,
	combineFilters,
	setRefreshSearch,
	selectedStatus,
	selectedAgent,
	updateStatusList,
	totalCount,
	disableFetching = false
}) {
	const resultsContainerRef = useRef(null);
	const updatePaginationStateSessionStorage = (key, value) => {
		const savedState = sessionStorage.getItem('paginationState');
		const currentState = savedState ? JSON.parse(savedState) : {};
		sessionStorage.setItem(
			'paginationState',
			JSON.stringify({
				...currentState,
				[key]: value
			})
		);
	};

	const getInitialPage = () => {
		let savedState = sessionStorage.getItem('paginationState');
		savedState = JSON.parse(savedState);

		if (savedState && (savedState.page !== undefined || savedState.page !== null)) {
			return savedState.page;
		} else {
			updatePaginationStateSessionStorage('page', 0);
			return 0;
		}
	};

	const getInitialRowsPerPage = () => {
		let savedState = sessionStorage.getItem('paginationState');
		savedState = JSON.parse(savedState);

		if (savedState && savedState.rowsPerPage) {
			return savedState.rowsPerPage;
		} else {
			updatePaginationStateSessionStorage('rowsPerPage', 10);
			return 10;
		}
	};

	const getStoredTotalCount = () => {
		// Make totalCount storage context-specific to avoid conflicts between Search and Task board
		const storageKey = isTaskBoard ? 'totalCount_taskboard' : 'totalCount_search';
		const savedCount = localStorage.getItem(storageKey);
		return savedCount ? parseInt(savedCount) : null;
	};

	const classes = useStyles({
		isDetailsTable: isDetailsTable,
		isSearchActivePage: isSearchActivePage
	});
	const [order, setOrder] = useState(initialSortOrder || 'desc');
	const [orderBy, setOrderBy] = useState(initialOrderBy);
	const [selected, setSelected] = useState([]);
	const [addressSelected, setAddressSelected] = useState([]);
	const [favSelected, setFavSelected] = useState([]);
	const [rows, setRows] = useState(listings);
	const [page, setPage] = useState(getInitialPage);
	const [rowsPerPage, setRowsPerPage] = useState(getInitialRowsPerPage);
	const [storedTotalCount, setStoredTotalCount] = useState(getStoredTotalCount());
	const [on, setOn] = useState(false);
	const [showPrint, setShowPrint] = useState(false);
	const [mapResultsOpen, setMapResultsOpen] = useState(false);
	const [newListings, setNewListings] = useState([]);
	const [oldRows, setOldRows] = useState([0]);
	const [printType, setPrintType] = useState();
	const [userState, dispatchUser] = useUserState();
	const [selectAgentOptions, setSelectAgentOptions] = useState([]);
	const [owner, setOwner] = useState(null);
	const [assignedInfo, setAssignedInfo] = useState({}); // object that holds active agents
	const [formSubmitObject, setFormSubmitObject] = useState({});
	const [open, setOpen] = useState(false);
	const [offset, setOffset] = useState(100);

	// // submit status updated after user has clicked save in edit modal
	const [submitSuccessStatus, setSubmitSuccessStatus] = useState(''); // keeps track of status when data is posted

	// for notification after user has clicked save in edit modal
	const [notificationState, setNotificationState] = useState(null); // used to open/close the notificaiton
	const [notificationMessage, setNotificationMessage] = useState(''); // used to set error message

	// ownerletter
	const [popupOwner, setPopupOwner] = useState(false);
	const [popupCustomOwner, setPopupCustomOwner] = useState(false);
	const [popupLoading, setPopupLoading] = useState(false);
	const [pdfOwnerUrl, setPdfOwnerUrl] = useState('');
	const [pdfCustomOwnerUrl, setPdfCustomOwnerUrl] = useState('');
	const [ownerLetterError, setOwnerLetterError] = useState(false);
	const [checkedLetterhead, setCheckedLetterhead] = useState(true);
	const [checkedUsername, setCheckedUsername] = useState(userState.checkedUsername);
	const [selectAll, setSelectAll] = useState(false);
	const [sendToCRMLoading, setSendToCRMLoading] = useState(false);
	const [assignmentLoading, setAssignmentLoading] = useState(false);

	// letter template
	const [letterTemplates, setLetterTemplates] = useState([]);
	const [selectedTemplate, setSelectedTemplate] = useState('');

	// screen size for responsive dialog
	const theme = useTheme();
	const fullScreen = useMediaQuery(theme.breakpoints.down('md')); // Fullscreen for small devices
	const largeScreen = useMediaQuery(theme.breakpoints.up('lg')); // Larger than large breakpoint
	const mediumScreen = useMediaQuery(theme.breakpoints.between('md', 'xl')); // Between md and lg breakpoints

	const navigation = useHistory();
	const [isUserPageChange, setIsUserPageChange] = useState(false);

	function descendingComparator(a, b, orderBy) {
		if (orderBy === 'Route') {
			return 0;
		}
		if (orderBy === 'Percent') {
			b[orderBy] = parseFloat(b[orderBy]);
			a[orderBy] = parseFloat(a[orderBy]);
		}
		if (b[orderBy] < a[orderBy]) {
			return -1;
		}
		if (b[orderBy] > a[orderBy]) {
			return 1;
		}
		return 0;
	}

	function filterListings() {
		let temp = [];

		for (var i = 0; i < listings.length; i++) {
			if (selected.includes(String(listings[i].MLNum) + '__' + String(listings[i].HomeId))) {
				temp.push(listings[i]);
			}
		}

		setNewListings(temp);
	}
	async function handleBeforePrint() {
		filterListings();
		await setOldRows(rowsPerPage);
		await setRowsPerPage(-1);
		await setShowPrint(true);
		await delay(5);
	}
	function onAfterPrint() {
		setShowPrint(false);
		setRowsPerPage(oldRows);
	}
	function getComparator(order, orderBy) {
		return order === 'desc'
			? (a, b) => descendingComparator(a, b, orderBy)
			: (a, b) => -descendingComparator(a, b, orderBy);
	}

	function stableSort(array, comparator) {
		const stabilizedThis = array.map((el, index) => [el, index]);
		stabilizedThis.sort((a, b) => {
			const order = comparator(a[0], b[0]);
			if (order !== 0) return order;
			return a[1] - b[1];
		});

		userState.offMarketSearchResults = stabilizedThis.map((el) => el[0]);
		localStorage.setItem('userState', JSON.stringify(userState));

		return stabilizedThis.map((el) => el[0]);
	}
	const handlePopupClose = () => {
		setPopup(false);
		setPopupOwner(false);
		setPopupCustomOwner(false);
	};
	const popupClick = () => {
		setPopup(true);
	};
	const handleRequestSort = (event, property) => {
		const isAsc = orderBy === property && order === 'asc';
		setOrder(isAsc ? 'desc' : 'asc');
		setOrderBy(property);
	};

	const resetPage = () => {
		// Don't trigger scroll when resetting page due to new search
		setIsUserPageChange(false);
		handleChangePage(null, 0);
	};

	const handleSelectAllClick = (event) => {
		if (event.target.checked) {
			const newSelecteds = stableSort(rows, getComparator(order, orderBy))
				.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
				.map((row) => row['MLNum'] + '__' + row['HomeId']);

			const newAddressSelecteds = stableSort(rows, getComparator(order, orderBy))
				.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
				.map((row) => row['Address']);

			let mergedSelected = [];
			let mergedAddressSelected = [];
			if (page === 0) {
				mergedSelected = newSelecteds;
				mergedAddressSelected = newAddressSelecteds;
			} else if (page > 0) {
				mergedSelected = selected.concat(newSelecteds);
				mergedAddressSelected = addressSelected.concat(newAddressSelecteds);
			}
			setSelected(mergedSelected);
			setAddressSelected(mergedAddressSelected);
			return;
		}
		setSelected([]);
		setAddressSelected([]);
	};
	let componentRef = useRef();

	const handleClick = (event, name, address) => {
		const selectedIndex = selected.indexOf(name);
		let newSelected = [];
		let newAddressSelected = [];

		if (selectedIndex === -1) {
			newSelected = newSelected.concat(selected, name);
			newAddressSelected = newAddressSelected.concat(addressSelected, address);
		} else if (selectedIndex === 0) {
			newSelected = newSelected.concat(selected.slice(1));
			newAddressSelected = newAddressSelected.concat(addressSelected.slice(1));
		} else if (selectedIndex === selected.length - 1) {
			newSelected = newSelected.concat(selected.slice(0, -1));
			newAddressSelected = newAddressSelected.concat(addressSelected.slice(0, -1));
		} else if (selectedIndex > 0) {
			newSelected = newSelected.concat(
				selected.slice(0, selectedIndex),
				selected.slice(selectedIndex + 1)
			);
			newAddressSelected = newAddressSelected.concat(
				addressSelected.slice(0, selectedIndex),
				addressSelected.slice(selectedIndex + 1)
			);
		}
		setSelected(newSelected);
		setAddressSelected(newAddressSelected);
	};

	const getAddress = (event, address) => {
		const selectedIndex = addressSelected.indexOf(address);
		let newSelected = [];

		if (selectedIndex === -1) {
			newSelected = newSelected.concat(addressSelected, address);
		} else if (selectedIndex === 0) {
			newSelected = newSelected.concat(addressSelected.slice(1));
		} else if (selectedIndex === addressSelected.length - 1) {
			newSelected = newSelected.concat(addressSelected.slice(0, -1));
		} else if (selectedIndex > 0) {
			newSelected = newSelected.concat(
				addressSelected.slice(0, selectedIndex),
				addressSelected.slice(selectedIndex + 1)
			);
		}
		setAddressSelected(newSelected);
	};

	const handleChangePage = (event, newPage) => {
		const mergedFilters = typeof combineFilters === 'function' ? combineFilters({}) : {};
		const totalPages = Math.ceil(rows.length / rowsPerPage);

		// Only set isUserPageChange to true if this is triggered by a real user event
		// When called programmatically during search, event will be null
		setIsUserPageChange(event !== null);

		if (mergedFilters && newPage >= totalPages) {
			setIsLoading(true);
			searchListing({ user: userState.user_id, filters: mergedFilters, offset: offset })
				.then((res) => {
					if (res.data.success) {
						let combineListings = [...listings, ...res.data.listings];
						setListings(combineListings);
						setOffset((prevOffset) => prevOffset + 100);
						setPage(newPage);
						setIsLoading(false);
						updatePaginationStateSessionStorage('page', newPage);
						dispatchUser({ offMarketSearchResults: combineListings });
					}
				})
				.catch((err) => {
					setIsLoading(false);
					console.log(err.message);
				});
		} else {
			setPage(newPage);
			updatePaginationStateSessionStorage('page', newPage);
		}
		setSelectAll(false);
		if (typeof setRefreshSearch === 'function') {
			setRefreshSearch(false);
		}
	};

	const handleChangeRowsPerPage = (event) => {
		const currPage = page;
		const currRowPerPage = rowsPerPage;
		const startingItem = currPage * currRowPerPage;

		const nextRowPerPage = parseInt(event.target.value, 10);
		const nextPage = Math.floor(startingItem / nextRowPerPage);
		setRowsPerPage(nextRowPerPage);
		setPage(nextPage);
		updatePaginationStateSessionStorage('rowsPerPage', nextRowPerPage);
		updatePaginationStateSessionStorage('page', nextPage);
	};

	const isSelected = (name) => selected.indexOf(name) !== -1;

	const emptyRows = rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);

	const onClickDelete = () => {
		setIsLoading(true);
		const data = {
			userId: userState.user.user_id,
			organizationId: userState.user.organization,
			listings: selected
		};
		deleteFromCollection(data)
			.then((res) => {
				if (res.data.success) {
					setSubmitSuccessStatus('success');
					setNotificationState(true);
					setNotificationMessage('Selected listings are deleted!');
					setIsLoading(false);
					fetchData();
				}
			})
			.catch((err) => {
				setSubmitSuccessStatus('error');
				if (err.response.status === 401) {
					setNotificationState(true);
					setNotificationMessage(
						'Your connection is time out. Please log in again to continue'
					);
					dispatchUser({
						isLoggedIn: false
					});
				}
				setIsLoading(false);
				console.log(err.message);
			});
		setSelected([]);
	};

	const onClickAssignTask = () => {
		if (handleAssignTask) handleAssignTask(selected, addressSelected);
	};

	const handleChangeLetterhead = (event) => {
		setCheckedLetterhead(event.target.checked);
		dispatchUser({ checkedLetterhead: event.target.checked });
	};

	const handleChangeUsername = (event) => {
		setCheckedUsername(event.target.checked);
		dispatchUser({ checkedUsername: event.target.checked });
	};

	const onClickOwnerLetter = async () => {
		setPdfOwnerUrl('');
		setOwnerLetterError(false);
		setPopupOwner(true);
	};

	const onClickCustomOwnerLetter = async () => {
		setPdfCustomOwnerUrl('');
		setOwnerLetterError(false);
		setPopupCustomOwner(true);
	};

	const extractMlNums = () => {
		const mlNumArr = [];
		// splits the selected array into mlnum
		selected.map((select) => {
			let mlNum;
			const splitResult = select.split('__');
			if (splitResult.length > 0) {
				mlNum = splitResult[0];
			} else {
				mlNum = select;
			}
			mlNumArr.push(mlNum);
		});
		return mlNumArr;
	};

	const onClickSave = () => {
		setIsLoading(true);
		const data = {
			userId: userState.user.user_id,
			organizationId: userState.user.organization,
			listings: selected
		};

		saveSelection(data)
			.then((res) => {
				if (res.data.success) {
					setSubmitSuccessStatus('success');
					setNotificationState(true);
					setNotificationMessage('Selected listings are saved!');
					setIsLoading(false);
					fetchData();
				}
			})
			.catch((err) => {
				setSubmitSuccessStatus('error');
				if (err.response.status === 401) {
					setNotificationState(true);
					setNotificationMessage(
						'Your connection is time out. Please log in again to continue'
					);
					dispatchUser({
						isLoggedIn: false
					});
				}
				setIsLoading(false);

				console.log(err.message);
			});
		setSelected([]);
	};

	const onClickRoutes = () => {
		if (handleRoutes) handleRoutes(selected);
	};

	const onClickPlanMyRoutes = (event) => {
		event.preventDefault();
		dispatchUser({ selectedRoutes: null });
		dispatchUser({ selectedRoutes: extractMlNums(selected) });
		navigation.push({
			pathname: '/user/planning-routes',
			state: { from: navigation.location.pathname }
		});
	};

	const onClickSendToFUB = (event) => {
		setSendToCRMLoading(true);
		const data = {
			userId: userState.user.user_id,
			organizationId: userState.user.organization,
			listings: extractMlNums()
		};
		sendToFollowUpBoss(data)
			.then((res) => {
				if (res.data.success) {
					setSendToCRMLoading(false);
					setNotificationState(true);
					const data = res.data.results;
					const sent = data['sent'];
					const failed = data['failed'];
					if (failed && failed.length <= 0) {
						setSubmitSuccessStatus('success');
						setNotificationMessage(`Successfully sent ${sent.length} lead to the CRM!`);
					} else {
						setSubmitSuccessStatus('error');
						setNotificationMessage(
							`Sent ${sent.length} to the CRM. Failed to send ${failed
								.map((item) => {
									return item;
								})
								.join(', ')}.`
						);
					}
				}
			})
			.catch((err) => {
				if (err.response && err.response.status === 400) {
					setSubmitSuccessStatus('error');
					setNotificationState(true);
					setNotificationMessage('Your organization has not set up their API key yet.');
				} else if (err.response.status === 401) {
					setIsLoading(false);
					setNotificationState(true);
					setNotificationMessage(
						'Your connection is time out. Please log in again to continue'
					);
					dispatchUser({
						isLoggedIn: false
					});
				} else if (err.response && err.response.status === 406) {
					setSubmitSuccessStatus('error');
					setNotificationState(true);
					setNotificationMessage(
						`No results were found with your selection${
							selected && selected.length > 1 ? 's.' : '.'
						}`
					);
				}
				setIsLoading(false);

				console.log(err.message);
			});
	};

	const onClickPrint = () => {
		console.log('Print');
	};
	const onClickSelect = () => {
		const oldListings = listings;
		if (handleSelect && on === false) {
			handleSelect(selected, on);
		} else {
			handleSelect(oldListings, on);
			// listings = oldListings;
			setSelected(selected);
		}
		//('Select all selected listings');
		setOn(!on);
	};

	const [errMsg, setErrMsg] = useState('');
	const [homeTagsAndComms, setHomeTagsAndComms] = useState({});

	const onHoverAPI = async (e, homeId) => {
		e.preventDefault();
		if (homeTagsAndComms.hasOwnProperty(homeId)) {
			return;
		}
		try {
			const [commentsResp, tagsResp] = await Promise.all([
				getHomeCommentsByOrganization(homeId, 5),
				getHomeTagsByOrganization(homeId)
			]);
			setHomeTagsAndComms((prevState) => ({
				...prevState,
				[homeId]: {
					comments: commentsResp.data.comments,
					tags: tagsResp.data.tags.slice(0, 2),
					loading: false
				}
			}));
		} catch (error) {
			setSubmitSuccessStatus('error');
			if (error.response.status === 401) {
				setNotificationState(true);
				setNotificationMessage(
					'Your connection is time out. Please log in again to continue'
				);
				return;
			}
			setErrMsg('Error while loading tags!');
			console.log(error.message);
		}
	};
	useEffect(() => {
		setRows(listings);
	}, [listings]);

	const fetchData = async (unmounted) => {
		searchMyCollection()
			.then((res) => {
				if (res.status === 200) {
					setFavSelected(res.data.listings.map((listing) => listing.HomeId));
					setIsLoading(false);
				}
				if (!unmounted) {
					setIsLoading(false);
				}
			})
			.catch((err) => {
				setSubmitSuccessStatus('error');
				if (err.response.status === 401) {
					setNotificationState(true);
					setNotificationMessage(
						'Your connection is time out. Please log in again to continue'
					);
					dispatchUser({
						isLoggedIn: false
					});
				} else if (!unmounted) {
					setIsLoading(false);
					setErrMsg('Error while loading listing!');
				}
				console.log(err.message);
			});
		resetPage();
	};

	// fetch favorites from collection
	useEffect(() => {
		if (isLoading) {
			return;
		}

		if (disableFetching) {
			return;
		}

		let unmounted = false;
		fetchData(unmounted);

		return () => {
			unmounted = true;
		};
	}, []);

	const handleRoutes = (selListings) => {
		if (selListings.length > 25) {
			setSubmitSuccessStatus('error');
			setNotificationState(true);
			setNotificationMessage(
				'The maximum number of selections permitted for route calculation is 25.'
			);
			return;
		}
		// display loading pop up until new tab opened
		setIsLoading(true);
		const data = {
			listings: selListings
		};
		getRoutesForSelection(data)
			.then((res) => {
				if (res.data.success) {
					let url = res.data.result.path;
					window.open(url, '_blank', 'noreferrer');
				}
				setIsLoading(false);
			})
			.catch((err) => {
				setSubmitSuccessStatus('error');
				if (err.response.status === 401) {
					setNotificationState(true);
					setNotificationMessage(
						'Your connection is time out. Please log in again to continue'
					);
					dispatchUser({
						isLoggedIn: false
					});
				}
				console.log(err.message);
				setIsLoading(false);
			});
	};

	const addDataToFormObject = (key, value) => {
		// everytime user clicks save we save all data
		setFormSubmitObject((prevObject) => {
			return { ...prevObject, [key]: value };
		});
	};

	const clearKeys = (obj) => {
		// this function clears the form field if the user closes or saves changes
		// the desired keys are kept, so that the edit modal still works
		const desiredKeysToKeep = ['city'];

		return Object.fromEntries(
			Object.entries(obj).filter(([key, value]) => desiredKeysToKeep.includes(key))
		);
	};

	const handleAssignTask = (listings, addressSelected) => {
		const fetchAgentOptionsIdValue = async (mapAgentInfoToOptions) => {
			// if (editAssignedTaskVisible) {
			const agentsRes = await getActiveAgents();
			try {
				if (agentsRes.data.success) {
					if (assignMyself) {
						let options = [];
						options.push({
							label: userState['user'].name,
							value: userState['user'].user_id
						});
						options.push({ label: 'Unassign', value: '-1' });
						setSelectAgentOptions(options);
					} else {
						const options = mapAgentInfoToOptions(agentsRes.data.agents);
						options.push({ label: 'Unassign', value: '-1' });
						setSelectAgentOptions(options);
						console.log('what is the agent options?', selectAgentOptions);
					}
				}
			} catch (err) {
				if (agentsRes.status === 401) {
					return dispatchUser({ isLoggedIn: false });
				}
				console.log(err.message);
			}
			// }
		};

		const mapAgentInfoToOptions = (agentArr) => {
			// this function formats the possible options to an array holding objects of the form {name: string, uuid: string}
			return agentArr.map((agent) => {
				return { label: agent.name, value: agent.uuid };
			});
		};

		fetchAgentOptionsIdValue(mapAgentInfoToOptions);
		setOpen(true);
		const mlNumArr = [];
		const homeIdArr = [];
		listings.map((select) => {
			const [mlNum, homeId] = select.split('__');
			mlNumArr.push(mlNum);
			homeIdArr.push(homeId);
		});
		addDataToFormObject('HomeIds', homeIdArr);
		addDataToFormObject('homeId', homeIdArr[0]);
		addDataToFormObject('mlNum', mlNumArr[0]);
		addDataToFormObject('HomeAddresses', addressSelected);
	};

	const handleSelectedAgent = () => {
		setAssignmentLoading(true);
		submitPropertyCustomData(formSubmitObject)
			.then((res) => {
				if (res.data.success) {
					handleClose();
					setSubmitSuccessStatus('success');
					setNotificationState(true);
					setNotificationMessage('Successfully assigned selected properties');

					if (isTaskBoard && selectedAgent != null && selectedStatus != null) {
						console.log('Taskboard handle agent');
						//Updates Taskboard to reflect changes
						getUserTaskBoard(selectedAgent, selectedStatus)
							.then((res) => {
								if (res.status === 200) {
									console.log(res.data.listings);
									setListings(res.data.listings);
									updateStatusList();
								}
								setAssignmentLoading(false);
							})
							.catch((err) => {
								setSubmitSuccessStatus('error');
								setNotificationState(true);
								setNotificationMessage('Error loading tasks');
								setAssignmentLoading(false);
								console.log(err.message);
							});
					} else {
						setAssignmentLoading(false);
					}
				}
			})
			.catch((err) => {
				setAssignmentLoading(false);
				// setSubmitSuccessStatus('error');
				if (err.response.status === 401) {
					dispatchUser({
						isLoggedIn: false
					});
					return;
				}
				setFormSubmitObject(clearKeys(formSubmitObject));
			});
		setSelected([]);
	};

	const handleClose = () => {
		setOpen(false);
		setAssignmentLoading(false);
	};

	const [popup, setPopup] = useState(false);
	const [tutorialOpen, setTutorialOpen] = useState(false);

	const OffMarketTable = ({ listings, newListings }) => {
		const selectedTable = (
			rowsPerPage > 0
				? stableSort(newListings, getComparator(order, orderBy)).slice(
						page * rowsPerPage,
						page * rowsPerPage + rowsPerPage
				  )
				: stableSort(newListings, getComparator(order, orderBy))
		).map((row) => {
			const isItemSelected = isSelected(row['MLNum'] + '__' + row['HomeId']);
			const isSelectedRoute = row['MLNum'] + '__' + row['HomeId'] === selectedRoute;
			return (
				<ListingCard
					key={row['MLNum'] + '__' + row['HomeId']}
					selected={isItemSelected}
					favSelected={favSelected.includes(row['HomeId'])}
					setFavSelected={setFavSelected}
					mlNum={row['MLNum']}
					status={row['Status']}
					homeId={row['HomeId']}
					address={row['Address']}
					price={row['Price']}
					assessment={row['assessment'] ? row['assessment'] : row['Assessment']}
					beds={row['TotBR']}
					bathrooms={row['TotBaths']}
					kitchens={row['NumKitchens']}
					totalArea={row['LotSzSqFt']}
					expiryDate={row['ExpiryDate']}
					knockability={row['Knockability']}
					expiry={row['ExpiryDate']}
					pic={row['Pics']}
					row={row}
					depth={row['Depth']}
					frontage={row['FrontageFeet']}
					propertyArea={row['TotFlArea']}
					onCheckClick={handleClick}
					getAddress={getAddress}
					selectedRoute={isSelectedRoute ? selectedRoute : null}
					planRoutes={planRoutes}
					openInNewTab={openInNewTab}
					AssignedAt={row['AssignedAt']}
					isTaskBoard={isTaskBoard}
					isSearchActivePage={isSearchActivePage}
				/>
			);
		});
		return <div>{selectedTable}</div>;
	};
	//Note that for ComponentToPrint, it needs to receive one single component of HTML, not an array of components.
	class ComponentToPrint extends React.Component {
		render() {
			return <OffMarketTable listings={listings} newListings={newListings} />;
		}
	}

	useEffect(() => {
		if (planRoutes) setRowsPerPage(30);
	}, [planRoutes]);

	// Only scroll to top when page changes due to user interaction
	useEffect(() => {
		if (isUserPageChange && resultsContainerRef.current) {
			resultsContainerRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
		} else if (isUserPageChange) {
			// Fallback to window scroll if ref isn't available
			window.scrollTo({
				top: 0,
				behavior: 'smooth'
			});
		}

		// Reset the flag after scrolling
		if (isUserPageChange) {
			setIsUserPageChange(false);
		}
	}, [page, isUserPageChange]);

	useEffect(() => {
		if (totalCount) {
			// Use context-specific storage keys to avoid conflicts between Search and Task board
			const currentStorageKey = isTaskBoard ? 'totalCount_taskboard' : 'totalCount_search';
			const otherStorageKey = isTaskBoard ? 'totalCount_search' : 'totalCount_taskboard';

			localStorage.setItem(currentStorageKey, totalCount.toString());
			setStoredTotalCount(totalCount);

			localStorage.removeItem(otherStorageKey);
		}
	}, [totalCount, isTaskBoard]);

	// Clear stored totalCount from other context
	useEffect(() => {
		const otherStorageKey = isTaskBoard ? 'totalCount_search' : 'totalCount_taskboard';
		localStorage.removeItem(otherStorageKey);
	}, [isTaskBoard]);

	useEffect(() => {
		if (totalCount !== undefined && totalCount !== null) {
			setStoredTotalCount(totalCount);
		}
	}, [totalCount]);

	return (
		<React.Fragment>
			{/* Add ref to the top element that should be visible after scrolling */}
			<div ref={resultsContainerRef}></div>
			<Snackbar
				anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
				open={notificationState}
				autoHideDuration={6000}
				onClose={() => setNotificationState(false)}
			>
				<Alert
					onClose={() => setNotificationState(false)}
					severity={submitSuccessStatus === 'success' ? 'success' : 'error'}
					variant="filled"
				>
					{notificationMessage}
				</Alert>
			</Snackbar>
			<div className={classes.printIconContainer}></div>
			{!isDetailsTable && selected.length > 0 && (
				<CusTableToolbarOffMarket
					isSearch={isSearch}
					isTaskBoard={isTaskBoard}
					title={title}
					styles={classes}
					selectedListings={selected}
					numSelected={selected.length}
					handleSelect={onClickSelect}
					handleSave={onClickSave}
					handleRoutes={onClickRoutes}
					handleDelete={onClickDelete}
					handleAssignTask={onClickAssignTask}
					handleOwnerLetter={onClickOwnerLetter}
					handleCustomOwnerLetter={onClickCustomOwnerLetter}
					handlePrint={onClickPrint}
					handlePlanMyRoutes={onClickPlanMyRoutes}
					handleFUBClick={onClickSendToFUB}
					popupClick={popupClick}
					onDeselect={() => setSelected([])}
					selectAll={selectAll}
					setSelectAll={setSelectAll}
					onSelectAllClick={handleSelectAllClick}
					editAssignedTaskVisible={editAssignedTaskVisible}
					assignMyself={assignMyself}
					sendToCRMLoading={sendToCRMLoading}
				/>
			)}
			{isSearch && (
				<React.Fragment>
					<div
						style={{
							display: 'flex',
							justifyContent: 'space-between',
							alignItems: 'center',
							marginTop: selected.length > 0 ? '1rem' : 0
						}}
					>
						<Grid
							container
							alignItems="center"
							justifyContent="space-between"
							className={classes.mapButton}
						>
							<Button color="secondary" onClick={() => setMapResultsOpen(true)}>
								View listings on Map
							</Button>
							<CusTableHead
								isSearch={isSearch}
								numSelected={selected.length}
								order={order}
								orderBy={orderBy}
								headCells={listHeads}
								onSelectAllClick={handleSelectAllClick}
								onRequestSort={handleRequestSort}
								rowCount={listings.length}
								setOrder={setOrder}
								setOrderBy={setOrderBy}
								resetPage={resetPage}
							/>
						</Grid>
					</div>
					<Table>
						<TableBody>
							<TableRow>
								<TablePagination
									className={classes.pagination}
									rowsPerPageOptions={planRoutes ? [30] : [10, 20, 30, 100]}
									colSpan={9}
									count={totalCount || storedTotalCount || rows.length}
									rowsPerPage={rowsPerPage}
									page={page}
									SelectProps={{
										inputProps: { 'aria-label': 'rows per page' },
										native: true
									}}
									onPageChange={handleChangePage}
									onRowsPerPageChange={handleChangeRowsPerPage}
									ActionsComponent={() =>
										CusPaginationActions({
											count: totalCount || storedTotalCount || rows.length,
											page,
											rowsPerPage,
											onChangePage: handleChangePage
										})
									}
								/>
							</TableRow>
						</TableBody>
					</Table>
					<Dialog
						maxWidth={largeScreen ? 'lg' : 'md'} // Use 'lg' for large screens, 'md' for medium
						fullWidth={!fullScreen} // Fullscreen only on small devices
						open={mapResultsOpen}
						onClose={() => setMapResultsOpen(false)}
						aria-labelledby="search"
						className={classes.mapResultDialog}
						PaperProps={{
							style: {
								width: largeScreen ? '80%' : '100%',
								height: largeScreen ? '80vh' : mediumScreen ? '70vh' : '90vh',
								maxWidth: 'none',
								maxHeight: '90vh'
							}
						}}
					>
						<DialogTitle id="map-search" onClose={() => setMapResultsOpen(false)}>
							{'Search Results'}
						</DialogTitle>
						<DialogContent dividers>
							<MapResults listings={listings} />
						</DialogContent>
					</Dialog>
				</React.Fragment>
			)}
			<Dialog
				open={open}
				onClose={handleClose}
				maxWidth="xs"
				PaperProps={{ classes: { root: classes.customDialog } }}
			>
				<DialogContent className={classes.dialogContentAgents}>
					<Typography variant="h5" component="h5" className={classes.subHeading}>
						Assign To agents
					</Typography>
					{assignmentLoading ? (
						<div
							style={{
								display: 'flex',
								justifyContent: 'center',
								alignItems: 'center',
								height: '100%',
								marginTop: '20px',
								marginBottom: '20px'
							}}
						>
							<CircularProgress />
						</div>
					) : (
						<Grid item style={{ width: '100%', marginTop: '16px' }}>
							<AssignTasks
								setOwner={setOwner}
								selectAgentOptions={selectAgentOptions}
								defaultAssignAgentStatusVal={assignedInfo}
								addDataToFormObject={addDataToFormObject}
							></AssignTasks>
						</Grid>
					)}
				</DialogContent>
				<DialogActions>
					<Button
						onClick={() => {
							setFormSubmitObject(clearKeys(formSubmitObject));
							handleClose();
						}}
						color="primary"
						size="large"
						disabled={assignmentLoading}
					>
						CANCEL
					</Button>
					<Button
						disabled={!owner || assignmentLoading}
						onClick={() => handleSelectedAgent()}
						color="primary"
						size="large"
					>
						{assignmentLoading ? 'ASSIGNING...' : 'SAVE'}
					</Button>
				</DialogActions>
			</Dialog>
			{popupCustomOwner && (
				<CustomOwnerLetterDialog
					open={popupCustomOwner}
					onClose={handlePopupClose}
					popupLoading={popupLoading}
					setPopupLoading={setPopupLoading}
					pdfCustomOwnerUrl={pdfCustomOwnerUrl}
					setPdfCustomOwnerUrl={setPdfCustomOwnerUrl}
					ownerLetterError={ownerLetterError}
					setOwnerLetterError={setOwnerLetterError}
					tutorialOpen={tutorialOpen}
					onTutorialClose={setTutorialOpen}
					userState={userState}
					extractMlNums={extractMlNums}
				/>
			)}
			{tutorialOpen && (
				<Dialog open={true} onClose={() => setTutorialOpen(false)} maxWidth="md" fullWidth>
					<DialogContent>
						<div style={{ position: 'relative', paddingTop: '56.25%' }}>
							<iframe
								style={{
									position: 'absolute',
									top: 0,
									left: 0,
									width: '100%',
									height: '100%'
								}}
								src="https://www.youtube.com/embed/MwDQnB9jKqY"
								title="Owner Letter Tutorial"
								frameBorder="0"
								allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
								allowFullScreen
							/>
						</div>
					</DialogContent>
				</Dialog>
			)}
			<Grid className={classes.resultsContainer}>
				<OffMarketTable listings={listings} newListings={listings} />
			</Grid>
			{!isSearch && (
				<Table>
					<TableBody>
						<TableRow>
							<TablePagination
								className={classes.pagination}
								rowsPerPageOptions={planRoutes ? [30] : [10, 20, 30, 100]}
								colSpan={9}
								count={rows.length}
								rowsPerPage={rowsPerPage}
								page={page}
								SelectProps={{
									inputProps: { 'aria-label': 'rows per page' },
									native: true
								}}
								onPageChange={handleChangePage}
								onRowsPerPageChange={handleChangeRowsPerPage}
								ActionsComponent={() =>
									CusPaginationActions({
										count: rows.length,
										page,
										rowsPerPage,
										onChangePage: handleChangePage
									})
								}
							/>
						</TableRow>
					</TableBody>
				</Table>
			)}
			{popup && (
				<Dialog open={true} onClose={handlePopupClose} className={classes.dialogBox}>
					<p className={classes.printListings}> Print Listings</p>
					<p className={classes.printScaleText}>
						Set print scale to 70 to fit everything
					</p>

					<DialogContent className={classes.dialogPrintContent}>
						<label>
							<input
								className={classes.checkBox}
								type="radio"
								checked={printType === 'summary'}
								onChange={() => setPrintType('summary')}
							/>
							<span>Print Summary</span>
						</label>
						<label className={classes.popupLabel}>
							<input
								className={classes.checkBox}
								type="radio"
								disabled="disabled"
								checked={printType === 'details'}
								onChange={() => setPrintType('details')}
							/>
							<span>Print Details </span>
							<span className={classes.comingSoon}>Coming Soon</span>
						</label>
						<div className={classes.printButtons}>
							<Button className={classes.summaryButton} onClick={handlePopupClose}>
								Cancel
							</Button>
							<ReactToPrint
								onBeforeGetContent={handleBeforePrint}
								onAfterPrint={onAfterPrint}
								trigger={() => (
									<Button className={classes.summaryButton}>Print</Button>
								)}
								content={() => componentRef}
							/>
						</div>
					</DialogContent>
				</Dialog>
			)}
			{showPrint && <ComponentToPrint ref={(el) => (componentRef = el)} />}
		</React.Fragment>
	);
}
